import * as Yup from "yup";

export const authSchema = Yup.object().shape({
  email: Yup.string()
    .email("Por favor, insira um email válido.")
    .required("Por favor, insira um email."),
  password: Yup.string().required("Por favor, insira uma senha."),
});
